import { Col } from "reactstrap";
import { RADIAL_PROGRESS_DATA } from "../../../../Data/Widgets/GeneralWidgets";
import CommonRadialProgress from "../../Common/CommonRadialProgress";

const RadialProgress = () => {
  return (
    <>
      {RADIAL_PROGRESS_DATA.map((item, index) => (
        <Col xl="3" sm="6" key={index}>
          <CommonRadialProgress data={item} />
        </Col>
      ))}
    </>
  );
};

export default RadialProgress;
